module.exports = __webpack_public_path__ + "static/media/loader_01.e39cdba7.gif";